// Strips emoji and kanji (CJK ideograph) characters from a string
const EMOJI_AND_KANJI_REGEX =
  /\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{Script=Han}|[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{1F3FB}-\u{1F3FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE0F}\u{200D}]/gu;

export const removeUnprintableCharacters = (text: string): string => text.replaceAll(EMOJI_AND_KANJI_REGEX, '');
